// envents
import events from '../authService/constants'
import event from '../authService/events'
import authService from '../authService'
import { filterStatesByAccess, findFirstAllowedStateName, hasRoleAccess } from '../util/stateAccess'
// helpers
import get from 'lodash/get'


export default function config(router) {
  router.transitionService.onBefore({}, transition => {
    const options = get(transition?.options(), 'custom', {})
    const from = transition.exiting()
    const actualView = from[0]

    if (options?.ignoreOnBefore) return Promise.resolve()

    const targetState = transition.to()
    const { roles } = authService.state.user || {}
    const isAllowed = hasRoleAccess(targetState, roles)

    if (!isAllowed) {
      const registeredStates = filterStatesByAccess(router.stateRegistry.get(), roles)
      const fallbackStateName = findFirstAllowedStateName(registeredStates, roles) || 'App'

      return transition.router.stateService.target(fallbackStateName, {}, {
        custom: { ...options, ignoreOnBefore: true },
      })
    }


    if (actualView?.data?.generalOnBefore)
      return new Promise((resolve, reject) => {
        event.emit(events?.GENERAL_ON_BEFORE, {
          resolve,
          reject,
          msg: actualView?.data?.generalOnBefore
        })
      })
  })

  return router.urlRouter.otherwise('/')
}